import React from 'react';
import styles from './System9Palaces.module.css';

const System9Palaces = () => {
  return (
    <section className={styles.system}>
      <div className={styles.container}>
        <h2 className={styles.heading}>Что такое система 9 Дворцов и почему это эксклюзивные знания</h2>
        <div className={styles.content}>
          <div className={styles.text}>
            <p>Прогноз по 9 Дворцам - это не просто гороскоп. Это персональный годовой навигатор на основе древней китайской метафизической системы 9 Дворцов, которая раньше была доступна только императорам и их приближенным.</p>
            <p>Система 9 Дворцов - это древняя китайская метафизическая система, менее известная широкой публике, чем Ба Цзы, но считающаяся более эксклюзивной и точной. Эти знания использовались императорами Китая для принятия важных решений: когда начинать войны, когда проводить реформы, когда заключать союзы.</p>
            <p>В основе лежит ваш персональный код рождения: точная дата, время и место рождения. Эта информация позволяет рассчитать вашу уникальную энергетическую карту, которая показывает, какие элементы поддерживают вас в 2026 году, какие энергии будут конфликтовать с вашей натальной картой, какие периоды года будут для вас благоприятными, а какие потребуют особой осторожности.</p>
            <p>В отличие от общих гороскопов, которые говорят одинаково для всех представителей знака зодиака, прогноз по системе 9 Дворцов рассчитывается индивидуально. Две женщины, родившиеся в один день, но в разное время или в разных местах, получат совершенно разные прогнозы.</p>
            <p>Наш прогноз использует не только систему 9 Дворцов, но и интегрирует элементы Ба Цзы для более точного расчета. Это дает вам преимущество: вы получаете более глубокий и детальный анализ, чем при использовании только одной системы.</p>
          </div>
          <div className={styles.imageWrapper}>
            <img 
              src="https://strategy.annavision.me/wp-content/uploads/2025/12/7b98ce6e89ccf86e46d43ed6345b7ef7_1766902356-1.png" 
              alt="Схема системы 9 Дворцов в золоте" 
              className={styles.systemImage}
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default System9Palaces;

